import { createContext } from 'react';
import { Location } from '../../utils/interfaces/place';

export type LocationContextType = {
   location: Location;
};

const LocationContext = createContext<LocationContextType>({
   location: { countryCode: '' },
});

export default LocationContext;
